var map = {
	"./ad.svg": 92105,
	"./al.svg": 13869,
	"./am.svg": 53621,
	"./at.svg": 83010,
	"./australia.svg": 8697,
	"./austria.svg": 4566,
	"./ba.svg": 2189,
	"./belgium.svg": 30310,
	"./bulgaria.svg": 39406,
	"./canada.svg": 20915,
	"./ch.svg": 34834,
	"./china.svg": 37016,
	"./croatia.svg": 29715,
	"./cyprus.svg": 57470,
	"./cz.svg": 96048,
	"./czech.svg": 2452,
	"./denmark.svg": 53332,
	"./egypt.svg": 89542,
	"./estonia.svg": 38264,
	"./finland.svg": 5117,
	"./france.svg": 8122,
	"./gb.svg": 26522,
	"./georgia.svg": 10979,
	"./germany.svg": 47462,
	"./greece.svg": 26606,
	"./hk.svg": 79821,
	"./hu.svg": 86650,
	"./hungary.svg": 89930,
	"./id.svg": 58117,
	"./india.svg": 92478,
	"./ireland.svg": 26196,
	"./is.svg": 88577,
	"./italy.svg": 57804,
	"./jp.svg": 69099,
	"./kz.svg": 95008,
	"./latvia.svg": 34075,
	"./lithuania.svg": 41452,
	"./luxembourg.svg": 52945,
	"./malta.svg": 25461,
	"./mc.svg": 46801,
	"./md.svg": 2920,
	"./me.svg": 50707,
	"./mk.svg": 90341,
	"./netherlands.svg": 67824,
	"./no.svg": 46205,
	"./poland.svg": 95758,
	"./portugal.svg": 61098,
	"./romania.svg": 76905,
	"./rs.svg": 47372,
	"./russia.svg": 45172,
	"./singapore.svg": 39466,
	"./slovakia.svg": 27970,
	"./slovenia.svg": 99881,
	"./sm.svg": 87376,
	"./spain.svg": 26201,
	"./sweden.svg": 58476,
	"./tr.svg": 63088,
	"./ua.svg": 48800,
	"./us.svg": 52030,
	"./va.svg": 82922,
	"./xk.svg": 79889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26448;